import { useMutation, useQuery } from "@apollo/client";
import { LocationGenerics } from "router/location";
import { wrapClick } from "utils";
import { DisapproveServiceOrderForm } from "components/forms";
import { Modal } from "components/layouts";
import { useFormik } from "formik";
import toast from "react-hot-toast";
import { useSearch } from "react-location";
import { DISAPPROVE_SERVICE_ORDER, GET_SERVICE_ORDER } from "./apollo";

export default function DisapproveRATServiceOrderContainer({
  open,
  setOpen,
  refetch,
}: {
  open: boolean;
  setOpen: (open: boolean) => void;
  refetch?: () => void;
}) {
  const searchParams = useSearch<LocationGenerics>();
  const { data, loading } = useQuery(GET_SERVICE_ORDER, {
    variables: {
      id: searchParams.id,
    },
    notifyOnNetworkStatusChange: false,
    skip: !searchParams.id,
  });
  const [disapproveServiceOrder] = useMutation(DISAPPROVE_SERVICE_ORDER);

  const form = useFormik({
    initialValues: {
      reason: "",
    },
    onSubmit: async (values) => {
      await disapproveServiceOrder({
        variables: {
          id: searchParams.id,
          ...values,
        },
      }).then(({ data: result }) => {
        if (result?.disapproveServiceOrder?._id) {
          toast(
            JSON.stringify({
              type: "success",
              title: "RAT Service Order Disapproved Successfully",
            }),
          );
          refetch?.();
          form.resetForm();
          setOpen(false);
        } else {
          toast(
            JSON.stringify({
              type: "error",
              title: "Could not disapprove RAT Service Order",
            }),
          );
        }
      });
    },
    onReset: () => {
      setOpen(false);
    },
  });

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      title="Disapprove Readiness Assessment Test"
      description="Provide reasons for disapproving this readiness assessment test"
      loading={loading}
      renderActions={() => (
        <button
          type="button"
          disabled={form.isSubmitting}
          className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
          onClick={wrapClick(form.handleSubmit)}
        >
          {form.isSubmitting ? "Disapproving..." : "Disapprove Order"}
        </button>
      )}
    >
      {data?.serviceOrder?._id && <DisapproveServiceOrderForm form={form} />}
    </Modal>
  );
}
